import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-20 text-center">
        <span className="font-heading text-7xl font-black text-background-300 md:text-[10rem]">
          404
        </span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这份档案不存在
        </h1>
        <p className="mt-3 font-mono text-sm text-foreground-400">{location.pathname}</p>
        <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
          你访问的页面可能已被移动或尚未归档。回到首页，或前往深挖专区浏览已发布的深度专题。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/topics"
            className="whitespace-nowrap rounded-md border border-foreground-950 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            浏览深挖专区
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}